import watchGetDSMRequested from './getDSMSaga';
import watchAddStatusMessageRequested from './addStatusMessageSaga';

export default [
  watchGetDSMRequested(),
  watchAddStatusMessageRequested(),
];
